import { makeRule } from '@core/utils/rule.js'

export let searchRules = {
  id: [
    {...makeRule('请输入正确的付款管理ID', 'integer', 'blur', false), min: 1},
  ],
}

export let formRules = {

}

export let basicInfoFormRules = {
  type: [
    {...makeRule('请选择付款类型', 'integer')},
  ],
  payment_company: [
    {...makeRule('请选择付款公司', 'integer')},
  ],
  expected_date: [
    {...makeRule('付款加急时需选择期望日期', 'string')},
  ],
  desc: [
    {...makeRule('付款说明不能为空', 'string')},
  ],
}

export let payInfoformRules = {
  payment_channel_type: [
    {...makeRule('请选择付款渠道类型', 'integer')},
  ],
  payment_account_type: [
    {...makeRule('请选择付款账户类型', 'integer')},
  ],
  company_name: [
    {...makeRule('请设置收款对象名称', 'string')},
  ],
  bank_account: [
    {...makeRule('请输入银行账号', 'string')},
  ],
  bank: [
    {...makeRule('请输入开户银行支行', 'string')},
  ],
  bank_headquarters: [
    {...makeRule('请输入开户银行总行', 'string')},
  ],
}

export let reviewInfoformRules = {
  department_approver: [
    {...makeRule('请设置部门领导审批', 'integer')},
  ],
  first_approver: [
    {...makeRule('请设置一级审批', 'integer')},
  ],
  second_approver: [
    {...makeRule('请设置二级审批', 'integer')},
  ],
  third_approver: [
    {...makeRule('请设置三级审批', 'integer')},
  ],
  fourth_approver: [
    {...makeRule('请设置四级审批', 'integer')},
  ],
}

export let writeOffFormRules = {
  // amount: [
  //   {...makeRule('请输入冲销金额', 'string')},
  // ],
  // invoice_type: [
  //   {...makeRule('请选择发票类型', 'integer')},
  // ],
  // tax_rate: [
  //   {...makeRule('请选择税率', 'integer')},
  // ],
}



// WEBPACK FOOTER //
// ./src/views/payment-manager-new/payment-manager.rules.js